import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export default createReactClass({
	propTypes: {
		data: PropTypes.object.isRequired,
		active: PropTypes.bool,
		cats: PropTypes.object
	},

	render() {
		let image = null;
		let cat = this.props.cats[this.props.data.cat];
		let itemClass = 'slx-search__item slx-search__result';
		if (this.props.active) {
			itemClass += ' active';
		}
		if (this.props.data.image) {
			image = React.createElement('span', {
				style: {
					backgroundImage: `url(${this.props.data.image})`
				}
			});
		}

		return (
			<li className={itemClass}>
				<div className="slx-search__item__wrap">
					<div className="slx-search__image">{image}</div>
					<h4 className="slx-search__label">
						<a href={this.props.data.url}>{this.props.data.title}</a> {cat}
					</h4>
				</div>
			</li>
		);
	}
});
